<template>
    <div class="w-full">
        <fieldset class="border border-solid border-gray-300 mt-6 p-3 w-full">
            <legend class="text-sm">Decision Reasons</legend>

            <!-- Add new reason button -->
            <div class="mb-4">
                <Button name="Add Reason" icon="far fa-plus-circle" :method="addDecisionReason" />
            </div>

            <!-- Reasons list -->
            <div class="space-y-4">
                <div v-for="(reason, index) in decisionReasons" :key="index" class="p-4 bg-gray-50 rounded-lg relative">

                    <!-- Delete button -->
                    <button type="button" class="absolute top-2 right-2 text-red-500 hover:text-red-700"
                        @click="deleteDecisionReason(index)">
                        <i class="fa-solid fa-trash"></i>
                    </button>

                    <div class="grid md:grid-cols-3 gap-4">
                        <div>
                            <label class="block text-sm font-medium text-gray-700 mb-1">Decision Type</label>
                            <select :value="reason.decision_type"
                                @input="updateReason(index, 'decision_type', $event.target.value)"
                                class="form-input w-full">
                                <option :value="null">Select Type</option>
                                <option v-for="info in decisionInfos" :key="info.id" :value="info.id">
                                    {{ info.d_title }}
                                </option>
                            </select>
                        </div>
                        <div class="md:col-span-2">
                            <label class="block text-sm font-medium text-gray-700 mb-1">Reason</label>
                            <input type="text" :value="reason.decision_text"
                                @input="updateReason(index, 'decision_text', $event.target.value)"
                                class="form-input w-full" placeholder="Enter reason" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- No reasons message -->
            <div v-if="decisionReasons.length === 0" class="text-center text-gray-500 my-4">
                No decision reasons added yet
            </div>
        </fieldset>
    </div>
</template>
<script>
    import { computed, watch } from 'vue'
    import Button from '@/Shared/Button'
    import { useDecisionReasons } from '../composables/useDecisionReasons'

    export default {
        name: 'DecisionReason',

        components: {
            Button
        },

        props: {
            decisionReasons: {
                type: Array,
                default: () => []
            },
            decision_infos: {
                type: Array,
                default: () => []
            }
        },

        emits: ['update:decisionReasons'],

        setup(props, { emit }) {
            const {
                decisionReasons,
                decisionInfos,
                addDecisionReason,
                deleteDecisionReason,
                updateDecisionReason,
                isValid
            } = useDecisionReasons(props.decisionReasons, props.decision_infos)

            // Watch for changes in decisionReasons
            watch(decisionReasons, (newValue) => {
                emit('update:decisionReasons', newValue)
            }, { deep: true })

            const updateReason = (index, field, value) => {
                updateDecisionReason(index, field, value)
            }

            return {
                decisionReasons,
                decisionInfos,
                addDecisionReason,
                deleteDecisionReason,
                updateReason,
                isValid
            }
        }
    }
</script>
<style scoped>
    .form-input {
        border-radius: 0.375rem;
        border-color: #D1D5DB;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    }

    .form-input:focus {
        border-color: #6366F1;
        box-shadow: 0 0 0 1px #6366F1;
        outline: none;
    }
</style>
